import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'shared-wizzard-wrapper',
    templateUrl: './wizzard-wrapper.shared.component.html',
    styleUrls: ['./wizzard-wrapper.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WizzardWrapperComponent implements OnInit {
    @Input() public type: OLO.Components.WIZZARD_TYPE;
    @Input() public topPadding: boolean = false;

    constructor() { }

    ngOnInit(): void { }
}
